import React from 'react';
import { ButtonPrimary } from '@uberall/zenit';
import classnames from 'classnames';

import styles from './index.module.css';
import Message from '../../../Message';
import { SelectionListItem } from '../../../../contexts/types';

type ModalFooterButtonProps = {
    items: SelectionListItem[];
    onAdd: (items: SelectionListItem[]) => void;
};

const ModalFooterButton = ({ items, onAdd }: ModalFooterButtonProps) => {
    const hasCheckedItems = items.some((item) => item.checked);

    return (
        <ButtonPrimary
            disabled={!hasCheckedItems}
            className={classnames(styles.footerButton, {
                [styles.disabledButton]: !hasCheckedItems,
            })}
            onClick={onAdd}
        >
            <Message code="app.request.access.public.step.2.google.profile.modal.add" />
        </ButtonPrimary>
    );
};

export default ModalFooterButton;
